// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2mBtB","fileBtn":"File_fileBtn__2SNt8","closeBtn":"File_closeBtn__VzZ6E","fileSelected":"File_fileSelected__3o7yz","disabled":"File_disabled__29eNn"};